module.exports = __webpack_public_path__ + "media/application/images/demo/content_5-e13e7458458855bf8308cc6239856942.jpg";